import { API_BASE_URL } from '@/constants/api-base'

const state = {
  api: `${API_BASE_URL}/crm`,
  /* process.env.NODE_ENV === 'production'
    ? 'https://api.sushifox.ru/crm'
    : 'https://test.sushifox.ru/crm', */
  webApi: `${API_BASE_URL}/web`,
  storageApi: `${API_BASE_URL}/storage`,
  auth: {
    POST: {
      sendCode: '/auth/sendCode',
      login: '/auth/login',
      me: '/auth/me',
      refresh: '/auth/refresh',
      logout: '/auth/logout',
    },
  },
  admin: {
    GET: {
      fetchAdminShortInfo: '/administrator/getShortInfo',
      fetchBalance: '/administrator/getBalance',
    },
  },
  regions: {
    GET: {
      regionsList: '/regions',
      regionsSingle: '/regions/{id}',
    },
    POST: { regions: '/regions' },
    PUT: { regions: '/regions/{id}' },
    DELETE: { regions: '/regions/{id}' },
  },
  seo: {
    GET: {
      pageMetaList: '/seo/meta',
      pageMetaSingle: '/seo/meta/{id}',
    },
    POST: { pageMeta: '/seo/meta' },
    PUT: { pageMeta: '/seo/meta/{id}' },
    DELETE: { pageMeta: '/seo/meta/{id}' },
  },
  filials: {
    GET: {
      filialsList: '/filials',
      filialsSingle: '/filials/{id}',
    },
    POST: { filials: '/filials' },
    PUT: { filials: '/filials/{id}' },
    DELETE: { filials: '/filials/{id}' },
  },
  filialsSettings: {
    GET: {
      filialsSettingsList: '/settings',
      filialsSettingsSingle: '/settings/{id}',
    },
    POST: { filialsSettings: '/settings' },
    PUT: {
      filialsSettings: '/settings/{id}',
    },
    DELETE: { filialsSettings: '/settings/{id}' },
  },
  staff: {
    GET: {
      staffList: '/users',
      staffSingle: '/users/{id}',
      couriersInWork: '/users/couriersInWork',
    },
    POST: { staff: '/users' },
    PUT: { staff: '/users/{id}' },
    DELETE: { staff: '/users/{id}' },
  },
  roles: {
    GET: {
      rolesList: '/roles',
      availableList: '/roles/available',
      viewableList: '/roles/viewable',
      rolesSingle: '/roles/{id}',
    },
    POST: { roles: '/roles' },
    PUT: { roles: '/roles/{id}' },
    DELETE: { roles: '/roles/{id}' },
  },
  permissions: {
    GET: {
      permissions: '/permissions',
    },
  },
  upload: {
    POST: {
      image: '/common/uploadImage',
      doc: '/common/uploadDoc',
    },
  },
  suggests: {
    GET: {
      suggestNamesList: '/common/getSuggestName',
      suggestAddressList: '/common/getSuggestAddress',
      suggestCity: '/common/getSuggestCity',
      suggestStreetByCity: '/common/getSuggestStreetByCity',
      getSuggestStreetWithCity: '/common/getSuggestStreetWithCity',
      suggestStreet: '/common/getSuggestStreet',
      suggestHouse: '/common/getSuggestHouse',
      checkAddressIsDeliveryByString: '/common/checkAddressIsDeliveryByString',
    },
  },
  clients: {
    GET: {
      clientsList: '/clients',
      clientsSingle: '/clients/{id}',
      clientsAddressList: '/clientAddresses',
      clientInfo: '/clients/{id}/info',
    },
    POST: {
      clients: '/clients',
    },
    PUT: {
      clients: '/clients/{id}',
      clientsToBlackList: '/clients/{id}/toBlackList',
      clientsAddAddress: '/clients/{id}/addAddress',
      clientsEditAddress: '/clientAddresses/{id}',
      clientsAddPromoCode: '/clients/{id}/addPromoCode',
    },
    DELETE: {
      clients: '/clients/{id}',
    },
  },
  categories: {
    GET: {
      categoriesList: '/categories',
      categoriesSingle: '/categories/{id}',
    },
    POST: { categories: '/categories' },
    PUT: { categories: '/categories/{id}' },
    DELETE: { categories: '/categories/{id}' },
  },
  filialMenu: {
    GET: {
      categoriesList: '/filial-menu/categories',
      categoriesSingle: '/filial-menu/categories/{id}',
      collectionsList: '/filial-menu/collections',
      collectionsSingle: '/filial-menu/collections/{id}',
      menuItemsUpsalesList: '/filial-menu/items/upsales',
    },
  },
  modifications: {
    GET: {
      modificationsList: '/modifications',
      modificationsSingle: '/modifications/{id}',
    },
    POST: { modifications: '/modifications' },
    PUT: { modifications: '/modifications/{id}' },
    DELETE: { modifications: '/modifications/{id}' },
  },
  menuItems: {
    GET: {
      menuItemsList: '/menuItems',
      menuItemsSingle: '/menuItems/{id}',
      menuItemsExcell: '/menuItems/export/excell',
    },
    POST: { menuItems: '/menuItems' },
    PUT: { menuItems: '/menuItems/{id}' },
    DELETE: { menuItems: '/menuItems/{id}' },
  },
  technicalCards: {
    GET: {
      technicalCardsList: '/technicalCards',
      technicalCardsSingle: '/technicalCards/{id}',
    },
    POST: { technicalCards: '/technicalCards' },
    PUT: { technicalCards: '/technicalCards/{id}' },
    DELETE: { technicalCards: '/technicalCards/{id}' },
  },
  collections: {
    GET: {
      collectionsList: '/collections',
      collectionsSingle: '/collections/{id}',
    },
    POST: { collections: '/collections' },
    PUT: { collections: '/collections/{id}' },
    DELETE: { collections: '/collections/{id}' },
  },
  bundles: {
    GET: {
      bundlesList: '/bundles',
      bundlesSingle: '/bundles/{id}',
    },
    POST: { bundles: '/bundles' },
    PUT: { bundles: '/bundles/{id}' },
    DELETE: { bundles: '/bundles/{id}' },
  },
  baskets: {
    GET: {
      basketsSingle: '/baskets/{id}',
      basketsSingleByClient: '/clients/{id}/getClientCrmActiveBasket',
    },
    POST: {
      baskets: '/baskets',
      basketsAddItem: '/baskets/{id}/items',
    },
    PUT: {
      baskets: '/baskets/{id}',
    },
    PATCH: {
      basketChangeOnYandexDelivery: '/baskets/{id}/changeOnYandexDelivery',
      basketChangeOnDeliveryClub: '/baskets/{id}/changeOnDeliveryClub',
      basketsUpdateItem: '/baskets/items/{id}',
      basketsUpdatePayment: '/baskets/{id}/changePayment',
      basketsUpdateAddress: '/baskets/{id}/changeCourier',
      basketsChangePickup: '/baskets/{id}/changePickup',
      basketsUpdateComments: '/baskets/{id}/updateComments',
      updateClientRegistrationSource:
        '/baskets/{id}/updateClientRegistrationSource',
    },
    DELETE: {
      basketsDeleteItem: '/baskets/items/{id}',
    },
  },
  polygons: {
    POST: {
      polygons: '/geo/delivery-zones',
      importPreview: '/geo/delivery-zones/import/preview',
      importResolve: '/geo/delivery-zones/import/resolve',
      importApply: '/geo/delivery-zones/import/apply',
      restore: '/geo/delivery-zones/snapshots/{id}/restore',
      importRestore: '/geo/delivery-zones/import/{importId}/restore',
      jupiterImportStart: '/geo/delivery-zones/jupiter-import/{kind}',
    },
    GET: {
      polygonsList: '/polygons',
      deliveryZones: '/geo/delivery-zones',
      polygonsFilials: '/geo/delivery-zones/filials',
      export: '/geo/delivery-zones/export',
      history: '/geo/delivery-zones/history',
      snapshot: '/geo/delivery-zones/snapshots/{id}',
      restorePlan: '/geo/delivery-zones/snapshots/{id}/restore-plan',
      importRestorePlan: '/geo/delivery-zones/import/{importId}/restore-plan',
      jupiterImport: '/geo/delivery-zones/jupiter-import',
    },
    PUT: {
      polygonsUpdate: '/geo/delivery-zones/{id}',
    },
    PATCH: {
      filialTiers: '/geo/delivery-zones/filials/{filialId}/tiers',
      networkTiers: '/geo/delivery-zones/tiers',
    },
    DELETE: {
      polygonsDelete: '/geo/delivery-zones/{id}',
    },
  },
  orders: {
    POST: {
      orders: '/orders',
      ordersEmitCallback: '/common/callback',
      ordersCancelOrder: '/orders/{id}/cancel',
      ordersConfirmOrder: '/orders/{id}/confirm',
      printingCheck: '/printing/print-check',
      ordersStartPreparing: '/orders/{id}/preparing',
    },
    GET: {
      ordersSingle: '/orders/{id}',
      ordersList: '/orders',
      ordersStatusesList: '/order/getStatuses',
      ordersVersion: '/order/version',
      orderStateLog: '/orders/{id}/log',
    },
    PUT: {
      updateOrder: '/orders/{id}',
    },
    PATCH: {
      ordersChangeOnNextStatus: '/orders/{id}/changeOnNextStatus',
    },
  },
  promocodes: {
    GET: {
      promocodesList: '/promoCodes',
      personalPromocodesList: '/promoCodes/personal',
      promocodesSingle: '/promoCodes/{id}',
    },
    POST: {
      promocodes: '/promoCodes',
    },
    PUT: {
      promocodes: '/promoCodes/{id}',
    },
    DELETE: {
      promocodes: '/promoCodes/{id}',
    },
  },
  workSchedules: {
    GET: {
      workSchedulesList: '/workSchedules',
      workSchedulesScheme: '/workSchedules/getScheme/{id}',
      workSpacesList: '/workSpaces',
      workSpacesSingle: '/workSpaces/{id}',
      fetchCountStaffByDate: '/workSchedule/getCountStaffByDate',
      fetchWorkSchedulesDayData: '/workSchedules/getDay',
      fetchWorkSchedulesTables: '/reports/staff/workSchedules',
    },
    PUT: {
      workSpacesUpdate: '/workSpaces/{id}',
      updateWorkScheduleDay: '/workSchedules',
    },
    POST: {
      setWorkScheduleDay: '/workSchedules/setDay',
      updateWorkDay: '/workSchedules/updateWorkDay',
      startTransfer: '/workSchedules/startTransfer',
      completeTransfer: '/workSchedules/{id}/completeTransfer',
    },
  },
  promotions: {
    GET: {
      promotionsList: '/promotions',
      promotionsSingle: '/promotions/{id}',
    },
    POST: {
      promotions: '/promotions',
    },
    PUT: {
      promotions: '/promotions/{id}',
    },
    DELETE: {
      promotions: '/promotions/{id}',
    },
  },
  news: {
    GET: {
      newsList: '/news',
      newsSingle: '/news/{id}',
    },
    POST: {
      news: '/news',
    },
    PUT: {
      news: '/news/{id}',
    },
    DELETE: {
      news: '/news/{id}',
    },
  },
  slider: {
    GET: {
      sliderList: '/sliders',
      sliderSingle: '/sliders/{id}',
    },
    POST: {
      slider: '/sliders',
    },
    PUT: {
      slider: '/sliders/{id}',
    },
    DELETE: {
      slider: '/sliders/{id}',
    },
  },
  transactions: {
    GET: {
      transactionsList: '/transactions',
      transactionsSingle: '/transactions/{id}',
      canAcceptCollectTransaction: '/users/canAcceptCollectTransaction',
      transactionsSettings: '/transactions/settings',
    },
    POST: {
      transactionsCreate: '/transactions',
      sendAuthCode: '/transactions/sendAuthCode',
      createCollectionType: '/transactions/createCollectionType',
    },
    PUT: {
      transactionsUpdate: '/transactions/{id}',
    },
    PATCH: {
      transactionsCancel: '/transactions/{id}/canceled',
      transactionsWait: '/transactions/{id}/wait',
      completeCollectionType: '/transactions/{id}/completeCollectionType',
    },
  },
  indicators: {
    GET: {
      kitchenPerformance: '/kitchen/performance/all',
    },
  },
  marketing: {
    GET: {
      marketingSourcesList: '/marketing/marketingSources',
    },
  },

  /** STATISTIC **/
  stat: {
    GET: {
      fetchCourierStatisticTables: '/statistic/courier',
      fetchMenuAbcStatistic: '/statistic/menu/abc',
      fetchDayFilialMetrics: '/statistic/metrics/day',
      fetchMoneyByTypeStatistic: '/statistic/money/types',
      downloadMoneyByTypeStatistic: '/statistic/money/types/excel',
    },
  },

  couriers: {
    GET: {
      fetchCurrentGeoPositions: '/couriers/geo/current',
    },
  },

  priceLists: {
    GET: {
      fetchPriceLists: '/price-lists',
    },
  },

  reviews: {
    GET: {
      fetchFinalRating: '/statistic/reviews/rating/final',
    },
  },
}

const getters = {
  getBaseWebApiUrl (state) {
    return state.webApi
  },
  storage (state) {
    return state.storageApi
  },
  // Auth endpoint's
  authLogin (state) {
    return state.api + state.auth.POST.login
  },
  authMe (state) {
    return state.api + state.auth.POST.me
  },
  authRefresh (state) {
    return state.api + state.auth.POST.refresh
  },
  authLogout (state) {
    return state.api + state.auth.POST.logout
  },
  // Admin endpoints
  fetchAdminShortInfo (state) {
    return state.api + state.admin.GET.fetchAdminShortInfo
  },
  fetchBalance: (state) => {
    return state.api + state.admin.GET.fetchBalance
  },
  // Regions endpoint's
  regionsList (state) {
    return state.api + state.regions.GET.regionsList
  },
  regionsSingle: (state) => (payload) => {
    return (
      state.api + state.regions.GET.regionsSingle.replace(/\{id\}/g, payload)
    )
  },
  regionsCreate (state) {
    return state.api + state.regions.POST.regions
  },
  regionsEdit: (state) => (payload) => {
    return state.api + state.regions.PUT.regions.replace(/\{id\}/g, payload)
  },
  regionsDelete: (state) => (payload) => {
    return state.api + state.regions.DELETE.regions.replace(/\{id\}/g, payload)
  },
  // Brnaches endpoint's
  filialsList (state) {
    return state.api + state.filials.GET.filialsList
  },
  filialsSingle: (state) => (payload) => {
    return (
      state.api + state.filials.GET.filialsSingle.replace(/\{id\}/g, payload)
    )
  },
  filialsCreate (state) {
    return state.api + state.filials.POST.filials
  },
  filialsEdit: (state) => (payload) => {
    return state.api + state.filials.PUT.filials.replace(/\{id\}/g, payload)
  },
  filialsDelete: (state) => (payload) => {
    return state.api + state.filials.DELETE.filials.replace(/\{id\}/g, payload)
  },
  // Brnaches Deafult settings endpoint's
  filialsSettingsList (state) {
    return state.api + state.filialsSettings.GET.filialsSettingsList
  },
  filialsSettingsSingle: (state) => (payload) => {
    return (
      state.api +
      state.filialsSettings.GET.filialsSettingsSingle.replace(
        /\{id\}/g,
        payload,
      )
    )
  },
  filialsSettingsCreate (state) {
    return state.api + state.filialsSettings.POST.filialsSettings
  },
  filialsSettingsEdit: (state) => (payload) => {
    return (
      state.api +
      state.filialsSettings.PUT.filialsSettings.replace(/\{id\}/g, payload)
    )
  },
  filialsSettingsDelete: (state) => (payload) => {
    return (
      state.api +
      state.filialsSettings.DELETE.filialsSettings.replace(/\{id\}/g, payload)
    )
  },
  // Staff endpoint's
  staffList (state) {
    return state.api + state.staff.GET.staffList
  },
  staffSingle: (state) => (payload) => {
    return state.api + state.staff.GET.staffSingle.replace(/\{id\}/g, payload)
  },
  couriersInWork (state) {
    return state.api + state.staff.GET.couriersInWork
  },
  staffCreate (state) {
    return state.api + state.staff.POST.staff
  },
  staffEdit: (state) => (payload) => {
    return state.api + state.staff.PUT.staff.replace(/\{id\}/g, payload)
  },
  staffDelete: (state) => (payload) => {
    return state.api + state.staff.DELETE.staff.replace(/\{id\}/g, payload)
  },
  // Roles endpoint's
  rolesList (state) {
    return state.api + state.roles.GET.rolesList
  },
  availableRoleList (state) {
    return state.api + state.roles.GET.availableList
  },
  viewableRoleList (state) {
    return state.api + state.roles.GET.viewableList
  },
  rolesSingle: (state) => (payload) => {
    return state.api + state.roles.GET.rolesSingle.replace(/\{id\}/g, payload)
  },
  rolesCreate (state) {
    return state.api + state.roles.POST.roles
  },
  rolesEdit: (state) => (payload) => {
    return state.api + state.roles.PUT.roles.replace(/\{id\}/g, payload)
  },
  rolesDelete: (state) => (payload) => {
    return state.api + state.roles.DELETE.roles.replace(/\{id\}/g, payload)
  },
  // Permissions endpoint's
  permissions (state) {
    return state.api + state.permissions.GET.permissions
  },
  // Upload endpoint's
  uploadImage (state) {
    return state.api + state.upload.POST.image
  },
  uploadDoc (state) {
    return state.api + state.upload.POST.doc
  },
  // Clients endpont's
  clientsList (state) {
    return state.api + state.clients.GET.clientsList
  },
  clientsSingle: (state) => (payload) => {
    return (
      state.api + state.clients.GET.clientsSingle.replace(/\{id\}/g, payload)
    )
  },
  clientInfo: (state) => (payload) => {
    return state.api + state.clients.GET.clientInfo.replace(/\{id\}/g, payload)
  },
  clientsCreate (state) {
    return state.api + state.clients.POST.clients
  },
  clientsEdit: (state) => (payload) => {
    return state.api + state.clients.PUT.clients.replace(/\{id\}/g, payload)
  },
  clientsDelete: (state) => (payload) => {
    return state.api + state.clients.DELETE.clients.replace(/\{id\}/g, payload)
  },
  clientsToBlackList: (state) => (payload) => {
    return (
      state.api +
      state.clients.PUT.clientsToBlackList.replace(/\{id\}/g, payload)
    )
  },
  clientsAddressList (state) {
    return state.api + state.clients.GET.clientsAddressList
  },
  clientsAddAddress: (state) => (payload) => {
    return (
      state.api +
      state.clients.PUT.clientsAddAddress.replace(/\{id\}/g, payload)
    )
  },
  clientsEditAddress: (state) => (payload) => {
    return (
      state.api +
      state.clients.PUT.clientsEditAddress.replace(/\{id\}/g, payload)
    )
  },
  clientsAddPromoCode: (state) => (payload) => {
    return (
      state.api +
      state.clients.PUT.clientsAddPromoCode.replace(/\{id\}/g, payload)
    )
  },
  // filial-menu
  filialMenuCategoriesList (state) {
    return state.api + state.filialMenu.GET.categoriesList
  },
  filialMenuCategoriesSingle: (state) => (payload) => {
    return (
      state.api +
      state.filialMenu.GET.categoriesSingle.replace(/\{id\}/g, payload)
    )
  },
  filialMenuCollectionsList (state) {
    return state.api + state.filialMenu.GET.collectionsList
  },
  filialMenuCollectionsSingle: (state) => (payload) => {
    return (
      state.api +
      state.filialMenu.GET.collectionsSingle.replace(/\{id\}/g, payload)
    )
  },
  menuItemsUpsalesList: (state) => {
    return state.api + state.filialMenu.GET.menuItemsUpsalesList
  },
  // Categories endpoint's
  categoriesList (state) {
    return state.api + state.categories.GET.categoriesList
  },
  categoriesSingle: (state) => (payload) => {
    return (
      state.api +
      state.categories.GET.categoriesSingle.replace(/\{id\}/g, payload)
    )
  },
  categoriesCreate (state) {
    return state.api + state.categories.POST.categories
  },
  categoriesEdit: (state) => (payload) => {
    return (
      state.api + state.categories.PUT.categories.replace(/\{id\}/g, payload)
    )
  },
  categoriesDelete: (state) => (payload) => {
    return (
      state.api + state.categories.DELETE.categories.replace(/\{id\}/g, payload)
    )
  },
  // Modifications endpoint's
  modificationsList (state) {
    return state.api + state.modifications.GET.modificationsList
  },
  modificationsSingle: (state) => (payload) => {
    return (
      state.api +
      state.modifications.GET.modificationsSingle.replace(/\{id\}/g, payload)
    )
  },
  modificationsCreate (state) {
    return state.api + state.modifications.POST.modifications
  },
  modificationsEdit: (state) => (payload) => {
    return (
      state.api +
      state.modifications.PUT.modifications.replace(/\{id\}/g, payload)
    )
  },
  modificationsDelete: (state) => (payload) => {
    return (
      state.api +
      state.modifications.DELETE.modifications.replace(/\{id\}/g, payload)
    )
  },
  // Menu Items endpoint's
  menuItemsList (state) {
    return state.api + state.menuItems.GET.menuItemsList
  },
  downloadMenuItemsExcell (state) {
    return state.api + state.menuItems.GET.menuItemsExcell
  },
  menuItemsSingle: (state) => (payload) => {
    return (
      state.api +
      state.menuItems.GET.menuItemsSingle.replace(/\{id\}/g, payload)
    )
  },
  menuItemsCreate (state) {
    return state.api + state.menuItems.POST.menuItems
  },
  menuItemsEdit: (state) => (payload) => {
    return state.api + state.menuItems.PUT.menuItems.replace(/\{id\}/g, payload)
  },
  menuItemsDelete: (state) => (payload) => {
    return (
      state.api + state.menuItems.DELETE.menuItems.replace(/\{id\}/g, payload)
    )
  },
  // Technical Cards endpoint's
  technicalCardsList (state) {
    return state.api + state.technicalCards.GET.technicalCardsList
  },
  technicalCardsSingle: (state) => (payload) => {
    return (
      state.api +
      state.technicalCards.GET.technicalCardsSingle.replace(/\{id\}/g, payload)
    )
  },
  technicalCardsCreate (state) {
    return state.api + state.technicalCards.POST.technicalCards
  },
  technicalCardsEdit: (state) => (payload) => {
    return (
      state.api +
      state.technicalCards.PUT.technicalCards.replace(/\{id\}/g, payload)
    )
  },
  technicalCardsDelete: (state) => (payload) => {
    return (
      state.api +
      state.technicalCards.DELETE.technicalCards.replace(/\{id\}/g, payload)
    )
  },
  // Collections endpoint's
  collectionsList (state) {
    return state.api + state.collections.GET.collectionsList
  },
  collectionsSingle: (state) => (payload) => {
    return (
      state.api +
      state.collections.GET.collectionsSingle.replace(/\{id\}/g, payload)
    )
  },
  collectionsCreate (state) {
    return state.api + state.collections.POST.collections
  },
  collectionsEdit: (state) => (payload) => {
    return (
      state.api + state.collections.PUT.collections.replace(/\{id\}/g, payload)
    )
  },
  collectionsDelete: (state) => (payload) => {
    return (
      state.api +
      state.collections.DELETE.collections.replace(/\{id\}/g, payload)
    )
  },
  // Bundles endpoint's
  bundlesList (state) {
    return state.api + state.bundles.GET.bundlesList
  },
  bundlesSingle: (state) => (payload) => {
    return (
      state.api + state.bundles.GET.bundlesSingle.replace(/\{id\}/g, payload)
    )
  },
  bundlesCreate (state) {
    return state.api + state.bundles.POST.bundles
  },
  bundlesEdit: (state) => (payload) => {
    return state.api + state.bundles.PUT.bundles.replace(/\{id\}/g, payload)
  },
  bundlesDelete: (state) => (payload) => {
    return state.api + state.bundles.DELETE.bundles.replace(/\{id\}/g, payload)
  },
  // Suggest names endpoint's
  suggestNamesList (state) {
    return state.api + state.suggests.GET.suggestNamesList
  },
  suggestAddressList (state) {
    return state.api + state.suggests.GET.suggestAddressList
  },
  getSuggestCity (state) {
    return state.api + state.suggests.GET.suggestCity
  },
  getSuggestStreetByCity (state) {
    return state.api + state.suggests.GET.suggestStreetByCity
  },
  getSuggestStreetWithCity (state) {
    return state.api + state.suggests.GET.getSuggestStreetWithCity
  },
  getSuggestStreet (state) {
    return state.api + state.suggests.GET.suggestStreet
  },
  getSuggestHouse (state) {
    return state.api + state.suggests.GET.suggestHouse
  },
  checkAddressIsDeliveryByString (state) {
    return state.api + state.suggests.GET.checkAddressIsDeliveryByString
  },
  // Baskets endpoints
  basketsSingle: (state) => (payload) => {
    return (
      state.api + state.baskets.GET.basketsSingle.replace(/\{id\}/g, payload)
    )
  },
  basketsSingleByClient: (state) => (payload) => {
    return (
      state.api +
      state.baskets.GET.basketsSingleByClient.replace(/\{id\}/g, payload)
    )
  },
  basketsCreate (state) {
    return state.api + state.baskets.POST.baskets
  },
  basketsAddItem: (state) => (payload) => {
    return (
      state.api + state.baskets.POST.basketsAddItem.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdateItem: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketsUpdateItem.replace(/\{id\}/g, payload)
    )
  },
  basketChangeOnYandexDelivery: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketChangeOnYandexDelivery.replace(
        /\{id\}/g,
        payload,
      )
    )
  },
  basketChangeOnDeliveryClub: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketChangeOnDeliveryClub.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdatePayment: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketsUpdatePayment.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdateAddress: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketsUpdateAddress.replace(/\{id\}/g, payload)
    )
  },
  basketsChangePickup: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketsChangePickup.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdateComments: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.basketsUpdateComments.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdateInfo: (state) => (payload) => {
    return state.api + state.baskets.PUT.baskets.replace(/\{id\}/g, payload)
  },
  basketsDeleteItem: (state) => (payload) => {
    return (
      state.api +
      state.baskets.DELETE.basketsDeleteItem.replace(/\{id\}/g, payload)
    )
  },
  basketsUpdateClientRegistrationSource: (state) => (payload) => {
    return (
      state.api +
      state.baskets.PATCH.updateClientRegistrationSource.replace(
        /\{id\}/g,
        payload,
      )
    )
  },
  // Polygons endpoints
  polygonsCreate (state) {
    return state.api + state.polygons.POST.polygons
  },
  polygonsList (state) {
    return state.api + state.polygons.GET.polygonsList
  },
  deliveryZones (state) {
    return state.api + state.polygons.GET.deliveryZones
  },
  polygonsFilials (state) {
    return state.api + state.polygons.GET.polygonsFilials
  },
  polygonsDelete: (state) => (payload) => {
    return (
      state.api +
      state.polygons.DELETE.polygonsDelete.replace(/\{id\}/g, payload)
    )
  },
  polygonsUpdate: (state) => (id) =>
    state.api + state.polygons.PUT.polygonsUpdate.replace(/\{id\}/g, id),
  polygonsFilialTiers: (state) => (filialId) =>
    state.api + state.polygons.PATCH.filialTiers.replace(/\{filialId\}/g, filialId),
  polygonsNetworkTiers: (state) => state.api + state.polygons.PATCH.networkTiers,
  polygonsImportPreview: (state) => state.api + state.polygons.POST.importPreview,
  polygonsImportResolve: (state) => state.api + state.polygons.POST.importResolve,
  polygonsImportApply: (state) => state.api + state.polygons.POST.importApply,
  polygonsExport: (state) => state.api + state.polygons.GET.export,
  polygonsHistory: (state) => state.api + state.polygons.GET.history,
  polygonsSnapshot: (state) => (id) => state.api + state.polygons.GET.snapshot.replace(/\{id\}/g, id),
  polygonsRestorePlan: (state) => (id) => state.api + state.polygons.GET.restorePlan.replace(/\{id\}/g, id),
  polygonsRestore: (state) => (id) => state.api + state.polygons.POST.restore.replace(/\{id\}/g, id),
  polygonsImportRestorePlan: (state) => (importId) =>
    state.api + state.polygons.GET.importRestorePlan.replace(/\{importId\}/g, importId),
  polygonsImportRestore: (state) => (importId) =>
    state.api + state.polygons.POST.importRestore.replace(/\{importId\}/g, importId),
  polygonsJupiterImport: (state) => state.api + state.polygons.GET.jupiterImport,
  polygonsJupiterImportStart: (state) => (kind) =>
    state.api + state.polygons.POST.jupiterImportStart.replace(/\{kind\}/g, kind),
  // Orders endpoints
  ordersCreate (state) {
    return state.api + state.orders.POST.orders
  },
  ordersList (state) {
    return state.api + state.orders.GET.ordersList
  },
  ordersStatusesList (state) {
    return state.api + state.orders.GET.ordersStatusesList
  },
  ordersVersion (state) {
    return state.api + state.orders.GET.ordersVersion
  },
  ordersSingle: (state) => (payload) => {
    return state.api + state.orders.GET.ordersSingle.replace(/\{id\}/g, payload)
  },
  ordersCancelOrder: (state) => (payload) => {
    return (
      state.api +
      state.orders.POST.ordersCancelOrder.replace(/\{id\}/g, payload)
    )
  },
  ordersChangeOnNextStatus: (state) => (payload) => {
    return (
      state.api +
      state.orders.PATCH.ordersChangeOnNextStatus.replace(/\{id\}/g, payload)
    )
  },
  ordersStartPreparing: (state) => (payload) => {
  return (
    state.api +
    state.orders.POST.ordersStartPreparing.replace(/\{id\}/g, payload)
  )
},
  ordersConfirmOrder: (state) => (payload) => {
    return (
      state.api +
      state.orders.POST.ordersConfirmOrder.replace(/\{id\}/g, payload)
    )
  },
  getOrderStateLog: (state) => (payload) => {
    return (
      state.api + state.orders.GET.orderStateLog.replace(/\{id\}/g, payload)
    )
  },
  ordersEmitCallback (state) {
    return state.api + state.orders.POST.ordersEmitCallback
  },
  updateOrder: (state) => (payload) => {
    return state.api + state.orders.PUT.updateOrder.replace(/\{id\}/g, payload)
  },
  printingCheck (state) {
    return state.api + state.orders.POST.printingCheck
  },
  // Promocodes endpoints
  promocodesList (state) {
    return state.api + state.promocodes.GET.promocodesList
  },
  personalPromocodesList (state) {
    return state.api + state.promocodes.GET.personalPromocodesList
  },
  promocodesSingle: (state) => (payload) => {
    return (
      state.api +
      state.promocodes.GET.promocodesSingle.replace(/\{id\}/g, payload)
    )
  },
  promocodesCreate (state) {
    return state.api + state.promocodes.POST.promocodes
  },
  promocodesEdit: (state) => (payload) => {
    return (
      state.api + state.promocodes.PUT.promocodes.replace(/\{id\}/g, payload)
    )
  },
  promocodesDelete: (state) => (payload) => {
    return (
      state.api + state.promocodes.DELETE.promocodes.replace(/\{id\}/g, payload)
    )
  },
  // Work schedules endpoints
  workSchedulesList: (state) => {
    return state.api + state.workSchedules.GET.workSchedulesList
  },
  workSpacesList: (state) => {
    return state.api + state.workSchedules.GET.workSpacesList
  },
  workSpacesSingle: (state) => (payload) => {
    return (
      state.api +
      state.workSchedules.GET.workSpacesSingle.replace(/\{id\}/g, payload)
    )
  },
  workSchedulesScheme: (state) => (payload) => {
    return (
      state.api +
      state.workSchedules.GET.workSchedulesScheme.replace(/\{id\}/g, payload)
    )
  },
  workSpacesUpdate: (state) => (payload) => {
    return (
      state.api +
      state.workSchedules.PUT.workSpacesUpdate.replace(/\{id\}/g, payload)
    )
  },
  setWorkScheduleDay (state) {
    return state.api + state.workSchedules.POST.setWorkScheduleDay
  },
  updateWorkDay (state) {
    return state.api + state.workSchedules.POST.updateWorkDay
  },
  startWorkScheduleTransfer (state) {
    return state.api + state.workSchedules.POST.startTransfer
  },
  completeWorkScheduleTransfer: (state) => (payload) => {
    return (
      state.api +
      state.workSchedules.POST.completeTransfer.replace(/\{id\}/g, payload)
    )
  },
  updateWorkScheduleDay: (state) => {
    return state.api + state.workSchedules.PUT.updateWorkScheduleDay
  },
  fetchCountStaffByDate: (state) => (payload) => {
    return (
      state.api +
      state.workSchedules.GET.fetchCountStaffByDate.replace(/\{id\}/g, payload)
    )
  },
  fetchWorkSchedulesDayData: (state) => {
    return state.api + state.workSchedules.GET.fetchWorkSchedulesDayData
  },
  fetchWorkSchedulesTables: (state) => {
    return state.api + state.workSchedules.GET.fetchWorkSchedulesTables
  },
  // Promotions
  promotionsList (state) {
    return state.api + state.promotions.GET.promotionsList
  },
  promotionsSingle: (state) => (payload) => {
    return (
      state.api +
      state.promotions.GET.promotionsSingle.replace(/\{id\}/g, payload)
    )
  },
  promotionsCreate (state) {
    return state.api + state.promotions.POST.promotions
  },
  promotionsEdit: (state) => (payload) => {
    return (
      state.api + state.promotions.PUT.promotions.replace(/\{id\}/g, payload)
    )
  },
  promotionsDelete: (state) => (payload) => {
    return (
      state.api + state.promotions.DELETE.promotions.replace(/\{id\}/g, payload)
    )
  },
  // News
  newsList (state) {
    return state.api + state.news.GET.newsList
  },
  newsSingle: (state) => (payload) => {
    return state.api + state.news.GET.newsSingle.replace(/\{id\}/g, payload)
  },
  newsCreate (state) {
    return state.api + state.news.POST.news
  },
  newsEdit: (state) => (payload) => {
    return state.api + state.news.PUT.news.replace(/\{id\}/g, payload)
  },
  newsDelete: (state) => (payload) => {
    return state.api + state.news.DELETE.news.replace(/\{id\}/g, payload)
  },
  // Slider
  sliderList (state) {
    return state.api + state.slider.GET.sliderList
  },
  sliderSingle: (state) => (payload) => {
    return state.api + state.slider.GET.sliderSingle.replace(/\{id\}/g, payload)
  },
  sliderCreate (state) {
    return state.api + state.slider.POST.slider
  },
  sliderEdit: (state) => (payload) => {
    return state.api + state.slider.PUT.slider.replace(/\{id\}/g, payload)
  },
  sliderDelete: (state) => (payload) => {
    return state.api + state.slider.DELETE.slider.replace(/\{id\}/g, payload)
  },
  transactionsCreate (state) {
    return state.api + state.transactions.POST.transactionsCreate
  },
  transactionsSingle: (state) => (payload) => {
    return (
      state.api +
      state.transactions.GET.transactionsSingle.replace(/\{id\}/g, payload)
    )
  },
  transactionsUpdate: (state) => (payload) => {
    return (
      state.api +
      state.transactions.PUT.transactionsUpdate.replace(/\{id\}/g, payload)
    )
  },
  transactionsCancel: (state) => (payload) => {
    return (
      state.api +
      state.transactions.PATCH.transactionsCancel.replace(/\{id\}/g, payload)
    )
  },
  transactionsWait: (state) => (payload) => {
    return (
      state.api +
      state.transactions.PATCH.transactionsWait.replace(/\{id\}/g, payload)
    )
  },
  canAcceptCollectTransaction: (state) => {
    return state.api + state.transactions.GET.canAcceptCollectTransaction
  },
  transactionsSettings: (state) => {
    return state.api + state.transactions.GET.transactionsSettings
  },
  transactionsSendAuthCode (state) {
    return state.api + state.transactions.POST.sendAuthCode
  },
  createCollectionType (state) {
    return state.api + state.transactions.POST.createCollectionType
  },
  completeCollectionType: (state) => (payload) => {
    return (
      state.api +
      state.transactions.PATCH.completeCollectionType.replace(
        /\{id\}/g,
        payload,
      )
    )
  },
  indicatorsKitchenPerformance: (state) => {
    return state.api + state.indicators.GET.kitchenPerformance
  },
  marketingSourcesList: (state) => {
    return state.api + state.marketing.GET.marketingSourcesList
  },

  // Seo PageMetas endpoint's
  seoPageMetaList (state) {
    return state.api + state.seo.GET.pageMetaList
  },
  seoPageMetaSingle: (state) => (payload) => {
    return state.api + state.seo.GET.pageMetaSingle.replace(/\{id\}/g, payload)
  },
  seoPageMetaCreate (state) {
    return state.api + state.seo.POST.pageMeta
  },
  seoPageMetaEdit: (state) => (payload) => {
    return state.api + state.seo.PUT.pageMeta.replace(/\{id\}/g, payload)
  },
  seoPageMetaDelete: (state) => (payload) => {
    return state.api + state.seo.DELETE.pageMeta.replace(/\{id\}/g, payload)
  },
  // Stat Courier
  fetchCourierStatisticTables: (state) => {
    return state.api + state.stat.GET.fetchCourierStatisticTables
  },
  fetchMenuAbcStatistic: (state) => {
    return state.api + state.stat.GET.fetchMenuAbcStatistic
  },
  fetchDayFilialMetrics: (state) => {
    return state.api + state.stat.GET.fetchDayFilialMetrics
  },
  fetchMoneyByTypeStatistic: (state) => {
    return state.api + state.stat.GET.fetchMoneyByTypeStatistic
  },
  downloadMoneyByTypeStatistic: (state) => {
    return state.api + state.stat.GET.downloadMoneyByTypeStatistic
  },
  fetchCouriersCurrentGeoPositions: (state) => {
    return state.api + state.couriers.GET.fetchCurrentGeoPositions
  },
  fetchPriceLists: (state) => {
    return state.api + state.priceLists.GET.fetchPriceLists
  },
  fetchReviewsFinalRating: (state) => {
    return state.api + state.reviews.GET.fetchFinalRating
  },
}

export default {
  namespaced: true,
  state,
  getters,
}
